module.exports = __webpack_public_path__ + "static/media/notifications_enable_help.b7933642.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notifications_enable_help.jpg
// module id = 1862
// module chunks = 0